import { fetchToolLeads, deleteToolLead } from 'Features/Learning/ToolLeads/Utils/ToolLeadUtils';
import { setFilters } from 'Features/Learning/ToolLeads/toolLeadSlice';
import { handleDeleteConfirmation } from 'Utils/handleDelete';

export const fetchToolLeadList = (dispatch, filters) => {
	dispatch(fetchToolLeads(filters));
};

export const handleDeleteToolLead = async (dispatch, id, setRefetch) => {
	handleDeleteConfirmation({
		dispatch,
		id,
		setRefetch,
		deleteAction: deleteToolLead,
	});
};

export const handleBackPagination = (pagination, filters, dispatch, setRefetch) => {
	if (pagination?.current_page > 1) {
		dispatch(setFilters({
			...filters,
			page: pagination.current_page - 1,
		}));
		setRefetch((prev) => !prev);
	}
};

export const handleNextPagination = (pagination, filters, dispatch, setRefetch) => {
	if (pagination?.current_page < pagination?.last_page) {
		dispatch(setFilters({
			...filters,
			page: pagination.current_page + 1,
		}));
		setRefetch((prev) => !prev);
	}
};

export const handleClickPagination = (page, filters, dispatch, setRefetch) => {
	dispatch(setFilters({
		...filters,
		page,
	}));
	setRefetch((prev) => !prev);
};

export const formatWhatsappDisplay = (whatsapp) => {
	if (!whatsapp) return '-';
	const digits = String(whatsapp).replace(/\D/g, '');
	if (digits.startsWith('62')) {
		return `+${digits}`;
	}
	if (digits.startsWith('0')) {
		return `+62${digits.slice(1)}`;
	}
	return whatsapp;
};

export const buildWhatsappLink = (whatsapp, name) => {
	if (!whatsapp) return null;
	const digits = String(whatsapp).replace(/\D/g, '');
	let phone = digits;
	if (digits.startsWith('0')) {
		phone = `62${digits.slice(1)}`;
	} else if (!digits.startsWith('62')) {
		phone = `62${digits}`;
	}
	const text = encodeURIComponent(`Halo kak ${name || ''}, saya ingin bertanya terkait..`);
	return `https://wa.me/${phone}?text=${text}`;
};

export const formatDateTime = (value) => {
	if (!value) return '-';
	try {
		return new Date(value).toLocaleString('id-ID', {
			timeZone: 'Asia/Jakarta',
			day: '2-digit',
			month: 'short',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
		});
	} catch (_) {
		return value;
	}
};

export const TOOL_LABELS = {
	'skd-readiness': 'SKD Readiness',
	'interview-readiness': 'Interview Readiness',
	'tes-love-language': 'Tes Love Language',
	'tes-kepribadian': 'Tes Kepribadian',
	'cv-builder': 'CV Builder',
};

export const EXPORT_COLUMNS = [
	{ key: 'id', label: 'ID', defaultChecked: true },
	{ key: 'name', label: 'Nama', defaultChecked: true },
	{ key: 'email', label: 'Email', defaultChecked: true },
	{ key: 'whatsapp', label: 'WhatsApp', defaultChecked: true },
	{ key: 'tools_name', label: 'Tools', defaultChecked: true },
	{ key: 'attempts', label: 'Jumlah Pengisian', defaultChecked: true },
	{ key: 'consent_at', label: 'Waktu Persetujuan', defaultChecked: false },
	{ key: 'consent_version', label: 'Versi Persetujuan', defaultChecked: false },
	{ key: 'ip_address', label: 'IP Address', defaultChecked: false },
	{ key: 'data', label: 'Data Hasil (JSON)', defaultChecked: false },
	{ key: 'created_at', label: 'Dibuat', defaultChecked: true },
	{ key: 'updated_at', label: 'Diperbarui', defaultChecked: true },
];
